
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18.37 16.87"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M14.16 14.28h-3.74v-1h3.74A3.21 3.21 0 0 0 15.08 7H15l-.78-.2.56-.64a1.9 1.9 0 0 0 .43-1.21 1.88 1.88 0 0 0-3-1.52l-.48.35-.26-.55A4.22 4.22 0 0 0 7.84 1 3.76 3.76 0 0 0 4.9 2.23a4.51 4.51 0 0 0-1.27 3.44v.43l-.42.1a2.33 2.33 0 0 0-1.62 2.38h-1a3.36 3.36 0 0 1 2-3.22 5.59 5.59 0 0 1 1.58-3.82A4.74 4.74 0 0 1 7.89 0a5.27 5.27 0 0 1 4.17 2.28A2.82 2.82 0 0 1 13.28 2a2.88 2.88 0 0 1 2.88 2.9 3 3 0 0 1-.31 1.31 4.21 4.21 0 0 1-1.69 8.07z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M0 10.88h7.66v1H0zM0 13.37h7.66v1H0zM0 15.87h7.66v1H0z"}})])])])
          )
        }
      }
    